import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  supportsBulkSummaryToast,
  useProcesses,
  type IRydeProcess,
  type RydeProcessTitle,
  type RydeUiUnit,
  type TAddressedFieldsValueOnCompleted,
} from "@ryde/shared";

export const useWatchBulkProcessCompletion = ({
  entity,
  processTitle,
  addressedFieldsValueOnCompleted,
  toastSummaryOnComplete = supportsBulkSummaryToast(entity),
}: {
  entity: RydeUiUnit;
  processTitle: RydeProcessTitle;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
  toastSummaryOnComplete?: boolean;
}) => {
  const processKey = getActiveProcessKey(processTitle, entity);
  const activeProcess = useRecoilValue(activeProcessSF(processKey));
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle,
      process: activeProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
      toastSummaryOnComplete,
    });
  }, [
    activeProcess,
    addressedFieldsValueOnCompleted,
    entity,
    onComplete,
    processTitle,
    stopProcessPolling,
    t,
    toastSummaryOnComplete,
  ]);
};
